import { useState } from 'react'
import { useParams } from 'react-router-dom'

import DobUpsert from '../verifyContract/DobUpsert'
import * as api from 'helpers/api'
import { setPatientAccessToken } from 'helpers/patientSession'

interface IProps {
  nextStep: () => void
  title: string
  getOrder?: (id: number) => void
  poxShippingVerification?: boolean
  statementId?: string
  receiptId?: string
}

const Verify = ({
  nextStep,
  title,
  getOrder,
  statementId,
  receiptId,
  poxShippingVerification,
}: IProps) => {
  const { orderId, nonce } = useParams()
  const [error, setError] = useState('')

  const verifyDob = async (dob: string) => {
    try {
      setError('')
      const result = await api.get(`/patient/auth`, {
        dob,
        nonce,
        orderId,
        statementId,
        receiptId,
        poxShippingVerification,
      })
      if (result?.access_token) {
        setPatientAccessToken(result.access_token)
        if (getOrder) {
          await getOrder(Number(orderId))
        }
        nextStep()
      }
    } catch (err) {
      if (err.response.status >= 400 && err.response.status < 500) {
        setError('Invalid date of birth entered.')
      }
      console.log(err)
    }
  }

  return (
    <div className="container" style={{ maxWidth: 720 }}>
      <div className="mb-3">
        <h2>{title}</h2>
        <DobUpsert verifyDob={verifyDob} />
        <p className="text-danger">{error}</p>
      </div>
    </div>
  )
}

export default Verify
